import _Object$assign from "babel-runtime/core-js/object/assign";
import _regeneratorRuntime from "babel-runtime/regenerator";
import _Promise from "babel-runtime/core-js/promise";
import _asyncToGenerator from "babel-runtime/helpers/asyncToGenerator";

var _this2 = this;

import GROUP_INFO from "./QS421_groupInfo.js";
import oppService from "@/service/opp-service";

import bizOrgOcr from "../QS420/bizOcrInfo/bizOrgOcr";
import bizZdInfoNode from "../QS420/bizZdInfo/bizZdInfoNode";
import bizProImportantInfoNode from "./bizPro/bizProImportantInfo.js";
import bizManagerImportantInfo from "./bizPro/bizManagerImportantInfo.js";

import bizOrgOcrAgent from "../QS420/bizOcrInfo/bizOrgOcrAgent";
import bizOrgAgentBasicInfoNode from "../QS420/bizOcrInfo/bizOrgAgentBasicInfoNode";

import bizProBaseInfoNode from "./bizPro/bizProBaseInfo.js";

import bizManagerOtherInfo from "./bizPro/bizManagerOtherInfo.js";

import bizOtherLinkInfoNode from "../QS420/bizOther/bizOtherLinkInfoNode.js";
import bizOtherLegalInfoNode from "../QS420/bizOther/bizOtherLegalInfoNode.js";
import bizOtherAgentLinkInfoNode from "../QS420/bizOther/bizOtherAgentLinkInfoNode.js";

import bizControlModuleInfoNode from "../QS420/bizControl/bizControlStockInfoNode";
import bizControlCustomModuleInfoNode from "../QS420/bizControl/bizControlInfoNode";
import bizProActualControllerInfo from "./bizPro/bizProActualControllerInfo";
import bizControlBeneficiaryInfoNode from "../QS420/bizControl/bizBeneficiaryInfoNode";

import bizOtherCreditInfoNode from "../QS420/bizOther/bizOtherCreditInfoNode.js";
import bizTaxCustInfoNode from "../QS420/bizTaxInfo/bizTaxCustInfoNode";
import bizTaxContolInfoNode from "../QS420/bizTaxInfo/bizTaxContolInfoNode";

import bizProOtherInfoNode from "./bizPro/bizProOtherInfo.js";

import bizTrdAcctInfoNode from "../QS420/bizAcct/bizTrdAcctInfoNode";
import bizAcctBsbInfoNode from "../QS420/bizAcct/bizAcctBsbInfoNode";
import bizAcctAssetInfoNode from "../QS420/bizAcct/bizAcctAssetInfoNode";

import bizAgentPhoneInfoNode from "../QS420/bizPassword/bizAgentPhoneInfoNode";
import bizPasswordInfoNode from "../QS420/bizPassword/bizPasswordInfoNode";
import tools from "../QS420/QS420_tools";
import bizBenefitMethod from "@/business/businessTools/bizBenefitMethod";

var NODE_LIST = [bizOrgOcr, bizManagerImportantInfo, bizZdInfoNode, bizOrgAgentBasicInfoNode, bizOrgOcrAgent, bizProImportantInfoNode, bizProBaseInfoNode, bizManagerOtherInfo, bizOtherLinkInfoNode, bizOtherLegalInfoNode, bizOtherAgentLinkInfoNode, bizControlModuleInfoNode, bizControlCustomModuleInfoNode, bizProActualControllerInfo, bizControlBeneficiaryInfoNode, bizOtherCreditInfoNode, bizTaxCustInfoNode, bizTaxContolInfoNode, bizProOtherInfoNode, bizTrdAcctInfoNode, bizAcctBsbInfoNode, bizAcctAssetInfoNode, bizAgentPhoneInfoNode, bizPasswordInfoNode];
var isAllowOpenAcctSpecialOrg = function isAllowOpenAcctSpecialOrg(_this, params) {
  var subjectIdentityArr = ["6", "c"],
      customerInfo = _this.$storage.getJsonSession(_this.$definecfg.CUSTOMER_INFO),
      subjectIdentity = customerInfo.SUBJECT_IDENTITY,
      szOrgTypeArr = ["10", "11", "12", "13", "14", "33", "34", "41", "99a", "99b"],
      szOrgType = _this.groupDatas[GROUP_INFO.ORG.GROUP_ID][GROUP_INFO.ORG.BASIC.MODULE_ID][0].FIELDS.SZORG_TYPE.DEFAULT_VALUE;
  return szOrgTypeArr.includes(szOrgType) || subjectIdentityArr.includes(subjectIdentity);
};
var getImgBusiData = function getImgBusiData(_this, params) {
  var customerInfo = _this.$storage.getJsonSession(_this.$definecfg.CUSTOMER_INFO),
      bsbInfo = _this.groupDatas[GROUP_INFO.ACCT.GROUP_ID][GROUP_INFO.ACCT.BSB_INFO.MODULE_ID][0].FIELDS,
      TRDACCT_INFO_LIST = _.get(params, "BIZ_DATA.TRDACCT_INFO_LIST", []),
      szStkpbuVal = "",
      shStkpbuVal = "",
      IS_NEED_COLLECT_Xbf = 0;

  if (_this.openAcctType != "3" && (customerInfo.CUST_FNAME != bsbInfo.BSB_USER_FNAME.DEFAULT_VALUE || customerInfo.ID_TYPE != bsbInfo.BSB_ID_TYPE.DEFAULT_VALUE || customerInfo.ID_CODE != bsbInfo.BSB_ID_CODE.DEFAULT_VALUE)) {
    IS_NEED_COLLECT_Xbf = "1";
  } else {
    IS_NEED_COLLECT_Xbf = "0";
  }
  var shTrdAcctArr = [],
      SH_ACCT = "",
      szTrdAcctArr = [],
      SZ_ACCT = "";
  TRDACCT_INFO_LIST.map(function (item) {
    if (["00", "01"].includes(item.STKBD)) {
      szStkpbuVal = item.STKPBU;
    } else {
      shStkpbuVal = item.STKPBU;
    }
    var trdAcct = item.TRDACCT;
    if (item.OP_TYPE == "$SZA") {
      szTrdAcctArr.push(trdAcct ? "深A-" + trdAcct : "深A账户新开");
      SZ_ACCT = trdAcct ? trdAcct : "新开";
    }
    if (item.OP_TYPE == "$SHA") {
      shTrdAcctArr.push(trdAcct ? "沪A-" + trdAcct : "沪A账户新开");
      SH_ACCT = trdAcct ? trdAcct : "新开";
    }
  });
  var checkTrdacctObj = _.get(params, "DETAIL_DATA.checkTrdacctObj", []);

  var imgObj = {
    HAS_CONTRACT14: "",
    EXT_ORG: _this.groupDatas[GROUP_INFO.ACCT.GROUP_ID][GROUP_INFO.ACCT.ASSET_INFO.MODULE_ID][0].FIELDS.NEW_EXT_ORG.DEFAULT_VALUE,
    CUBSB_TRD_TYPE: "1",

    IS_OPEN_A: _.isEmpty(_.filter(checkTrdacctObj, function (value, key) {
      return value.hasSave == "1" && (key == "_11" || key == "_21");
    })) ? "0" : "1",

    IS_NEED_COLLECT_Xbf: IS_NEED_COLLECT_Xbf,

    IS_NEW_TRDACCT: _.isEmpty(_.filter(checkTrdacctObj, function (value, key) {
      return value.hasSave == "1" && value.SEL_TYPE == "1";
    })) ? "0" : "1",

    IS_OPEN_FUNDS: _.isEmpty(_.filter(checkTrdacctObj, function (value, key) {
      return value.hasSave == "1" && (key == "_13" || key == "_23");
    })) ? "0" : "1",
    SH_ACCT_TEXT: shTrdAcctArr.join(","),
    SZ_ACCT_TEXT: szTrdAcctArr.join(","),
    SH_ACCT: SH_ACCT,
    SZ_ACCT: SZ_ACCT,
    NEED_SYNC_CUST: _.get(params, "DETAIL_DATA.NEED_SYNC_CUST", ""),

    IS_SIGN_CONTRACT: "0",
    PROPER_CHECK_WITNESS_VIDEO: "",
    NEED_X41_IMG: "",

    HAS_CORP_QUAL: _this.groupDatas[GROUP_INFO.MANAGER.GROUP_ID][GROUP_INFO.MANAGER.OTHER.MODULE_ID][0].FIELDS.HAS_CORP_QUAL.DEFAULT_VALUE || _.get(params, "IMG_DATA.HAS_CORP_QUAL"),
    IS_CHECK_REGISTER_FUND: _this.groupDatas.MANAGER_INFO_PAGE.MANAGER_OTHER_INFO[0].FIELDS.REGISTER_FUND.isCheckCheckbox ? "1" : "0",
    IS_CHECK_PRO_BAK_CODE: _this.groupDatas.PRODUCT_INFO_PAGE.BASE_INFO[0].FIELDS.PRO_BAK_CODE.isCheckCheckbox ? "1" : "0",
    IS_PRO_TRUSTEE: _this.groupDatas.OTHER_INFO_PAGE.PRO_TRUSTEE_INFO[0].FIELDS.IS_PRO_TRUSTEE.DEFAULT_VALUE || ""
  };

  if (params.IS_AGENT === "0" || params.IS_AGENT === "1") {
    imgObj.IS_AGENT = params.IS_AGENT;
  } else {
    imgObj.IS_AGENT = _.get(params, "IMG_DATA.IS_AGENT");
  }
  return imgObj;
};
var getProCache = function getProCache(_this, fields) {
  if (!fields.CUST_FNAME.DEFAULT_VALUE || !fields.ID_TYPE.DEFAULT_VALUE || !fields.ID_CODE.DEFAULT_VALUE || _.get(_this, "historyData.BIZ_DATA.BASE_INFO.PRO_NAME", "")) {
    return;
  }
  _this.$store.commit(_this.$types.UPDATE_LOADING, "正在查询缓存信息...");
  return _this.$syscfg.K_Request("Y3032501", {
    prdName: fields.CUST_FNAME.DEFAULT_VALUE,
    idType: fields.ID_TYPE.DEFAULT_VALUE,
    idCode: fields.ID_CODE.DEFAULT_VALUE,
    type: "1"
  }).then(function (res) {
    var data = res.Data[0];
    if (!_.isEmpty(data)) {
      var confirmAction = function confirmAction() {
        var productInfo = {
          PRO_NAME: data.PRO_NAME,
          PRO_SNAME: data.PRO_SNAME,
          PRO_CLS: data.PRO_CLS,
          PRO_SIZE: data.PRO_SIZE,
          PRO_CREAT_DATE: data.PRO_CREAT_DATE,
          PRO_EXP_DATE: data.PRO_EXP_DATE,
          PRO_VAL: data.PRO_VAL,
          PRO_VAL_DATE: data.PRO_VAL_DATE,
          PRO_BAK_ORG: data.PRO_BAK_ORG,
          PRO_BAK_REMARK: data.PRO_BAK_REMARK,
          PRO_BAK_CODE: data.PRO_BAK_CODE,
          PRO_BAK_DATE: data.PRO_BAK_DATE,
          PRO_OPEN_DATE: data.PRO_OPEN_DATE,
          PRO_CON_SNO: data.PRO_CON_SNO,
          STRUCT_PRO_FLAG: data.STRUCT_PRO_FLAG,
          INIT_LEVERAGE: data.INIT_LEVERAGE,
          SMFUND_TYPE: data.SMFUND_TYPE,
          SMFUND_REMARK: data.SMFUND_REMARK,
          SMFUND_MANAGER_TYPE: data.SMFUND_MANAGER_TYPE,
          SMFUND_MANAGER_REMARK: data.SMFUND_MANAGER_REMARK,
          INVEST_RANAGE: data.INVEST_RANAGE
        };

        var proTrusteeInfo = {
          IS_PRO_TRUSTEE: data.IS_PRO_TRUSTEE,
          PRO_TRUSTEE_NAME: data.PRO_TRUSTEE_NAME,
          PRO_TRUSTEE_ID_TYPE: data.PRO_TRUSTEE_ID_TYPE,
          PRO_TRUSTEE_ID_CODE: data.PRO_TRUSTEE_ID_CODE,
          PRO_TRUSTEE_ASSI_CODE: data.PRO_TRUSTEE_ASSI_CODE,
          PRO_TRUSTEE_ID_EXP_DATE: data.PRO_TRUSTEE_ID_EXP_DATE
        };

        var investInfo = {
          IS_INVEST_ADVISER: data.IS_INVEST_ADVISER,
          INVEST_ORG_TYPE: data.INVEST_ORG_TYPE,
          INVEST_ADVISER: data.INVEST_ADVISER,
          INVESTASER_ID_TYPE: data.INVESTASER_ID_TYPE,
          INVESTASER_ID_CODE: data.INVESTASER_ID_CODE,
          INVEST_REP: data.INVEST_REP,
          INVEST_REP_ID_TYPE: data.INVEST_REP_ID_TYPE,
          INVEST_REP_ID_CODE: data.INVEST_REP_ID_CODE
        };

        var shareregInfo = {
          SHAREREG_ORG_TYPE: data.SHAREREG_ORG_TYPE,
          SHAREREG_ORG_NAME: data.SHAREREG_ORG,
          SHAREREG_ORG_ID_TYPE: data.SHAREREG_ORG_ID_TYPE,
          SHAREREG_ORG_ID_CODE: data.SHAREREG_ORG_ID_CODE
        };

        _.each(data.CONTROL_LIST_0, function (item) {
          return item.IS_SAME_LEGAL_REP = "0";
        });
        _.each(data.CONTROL_LIST_2, function (item) {
          return item.IS_SAME_LEGAL_REP = "0";
        });
        _.each(data.BENEFIT_LIST, function (item) {
          return item.IS_SAME_LEGAL_REP = "0";
        });

        _this.$blMethod.parseGroupsMouduleData(_this, ["BASE_INFO"], productInfo);
        _this.$blMethod.parseGroupsMouduleData(_this, ["PRO_TRUSTEE_INFO"], proTrusteeInfo);
        _this.$blMethod.parseGroupsMouduleData(_this, ["INVEST_INFO"], investInfo);
        _this.$blMethod.parseGroupsMouduleData(_this, ["SHAREREG_INFO"], shareregInfo);
        _this.$blMethod.parseMoudleArray(_this, _this.groupDatas["CONTROLER_INFO_PAGE"]["CONTROLER_MODULE"], data.CONTROL_LIST_0);
        _this.$blMethod.parseMoudleArray(_this, _this.groupDatas["CONTROLER_INFO_PAGE"]["CONTROLER_MODULE2"], data.CONTROL_LIST_2);

        var benefitListObj = bizBenefitMethod.getFilterBenefitListObj(data.BENEFIT_LIST);
        _this.$blMethod.parseMoudleArray(_this, _this.groupDatas["CONTROLER_INFO_PAGE"]["BENEFICIARY_MODULE"], benefitListObj.BENEFICIARY_MODULE);
        _this.$blMethod.parseMoudleArray(_this, _this.groupDatas["CONTROLER_INFO_PAGE"]["BENEFICIARY_MODULE_1"], benefitListObj.BENEFICIARY_MODULE_1);
        _this.$blMethod.parseMoudleArray(_this, _this.groupDatas["CONTROLER_INFO_PAGE"]["BENEFICIARY_MODULE_0"], benefitListObj.BENEFICIARY_MODULE_0);
        _this.$blMethod.parseMoudleArray(_this, _this.groupDatas["CONTROLER_INFO_PAGE"]["BENEFICIARY_MODULE_2"], benefitListObj.BENEFICIARY_MODULE_2);
        _this.$blMethod.parseMoudleArray(_this, _this.groupDatas["CONTROLER_INFO_PAGE"]["BENEFICIARY_MODULE_3"], benefitListObj.BENEFICIARY_MODULE_3);
        _this.$blMethod.parseMoudleArray(_this, _this.groupDatas["CONTROLER_INFO_PAGE"]["BENEFICIARY_MODULE_4"], benefitListObj.BENEFICIARY_MODULE_4);
        if (data.PRO_BAK_CODE == "0") {
          _this.groupDatas.PRODUCT_INFO_PAGE.BASE_INFO[0].FIELDS.PRO_BAK_CODE.isCheckCheckbox = true;
        } else {
          _this.groupDatas.PRODUCT_INFO_PAGE.BASE_INFO[0].FIELDS.PRO_BAK_CODE.isCheckCheckbox = false;
        }
      },
          canceledAction = function canceledAction() {
        return false;
      };
      _this.disabledArray.length == 0 && _this.$blMethod.showMsgBox(_this, "检测到当前产品信息已存在，是否直接复用？", confirmAction, canceledAction, "继续", "退出");
    }
    _this.$store.commit(_this.$types.UPDATE_LOADING, false);
  });
};

var getProManagerInfo = function getProManagerInfo(_this, fields) {
  if (!fields.PRO_MANAGER_NAME.DEFAULT_VALUE || !fields.ID_TYPE.DEFAULT_VALUE || !fields.ID_CODE.DEFAULT_VALUE || _.get(_this, "historyData.BIZ_DATA.MANAGER_INFO.PRO_MANAGER_NAME", "")) {
    return;
  }
  return _this.$syscfg.K_Request("Y3032501", {
    prdName: fields.PRO_MANAGER_NAME.DEFAULT_VALUE,
    idType: fields.ID_TYPE.DEFAULT_VALUE,
    idCode: fields.ID_CODE.DEFAULT_VALUE,
    type: "2"
  }).then(function (res) {
    var proCache = res.Data[0];
    if (!_.isEmpty(proCache)) {
      var confirmAction = function confirmAction() {
        var keyArr = ["PRO_MANAGER_NAME", "PRO_MANAGER_ENNAME", "SZORGTYPE", "PROF_INVESTOR_SOURCE", "BIRTHDAY", "REGISTER_FUND", "CITIZENSHIP", "SMFUND_MANAGER_ID", "PRO_MANAGER_BAK_DATE", "BUSINESS_RANGE", "INDUS_GB", "ORG_ID_CODE", "ORG_ID_EXP_DATE", "ID_TYPE", "ID_CODE", "ID_EXP_DATE", "CURRENCY", "ID_ADDR"];
        var tempData = _.pick(proCache, keyArr);

        var keyObj = {
          ID_TYPE: "PRO_MANAGER_ID_TYPE",
          ID_CODE: "PRO_MANAGER_ID_CODE",
          ID_EXP_DATE: "PRO_MANAGER_ID_EXP_DATE",
          CURRENCY: "REGISTER_CURRENCY",
          ID_ADDR: "OFFICE_ADDR",
          SZORG_TYPE: "SZORGTYPE"
        };

        _.each(keyObj, function (value, key) {
          tempData[key] = proCache[value];
        });

        if (proCache.source == "ecif") {
          _.each(keyArr, function (key) {
            tempData[key + "_DATA_SOURCE"] == "4";
          });
        } else {
          _.each(keyArr, function (key) {
            tempData[key + "_DATA_SOURCE"] == "";
          });
        }
        _this.$blMethod.parseGroupsMouduleData(_this, ["MANAGER_OTHER_INFO"], tempData);
        _this.$blMethod.parseGroupsMouduleData(_this, ["IMPORTANT_MODULE"], tempData);

        _this.$blMethod.parseGroupsMouduleDataSource(_this, ["MANAGER_OTHER_INFO"], tempData);
        _this.$blMethod.parseGroupsMouduleDataSource(_this, ["IMPORTANT_MODULE"], tempData);

        if (proCache.REGISTER_FUND == "0") {
          _this.groupDatas.MANAGER_INFO_PAGE.MANAGER_OTHER_INFO[0].FIELDS.REGISTER_FUND.isCheckCheckbox = true;
        } else {
          _this.groupDatas.MANAGER_INFO_PAGE.MANAGER_OTHER_INFO[0].FIELDS.REGISTER_FUND.isCheckCheckbox = false;
        }

        var legalInfo = {
          LEGAL_REP: proCache.LEGAL_REP,
          LEGAL_REP_DATA_SOURCE: proCache.source == "ecif" ? "4" : "",
          LEGAL_REP_ID_TYPE: proCache.LEGAL_REP_ID_TYPE,
          LEGAL_REP_ID_TYPE_DATA_SOURCE: proCache.source == "ecif" ? "4" : "",
          LEGAL_REP_ID_CODE: proCache.LEGAL_REP_ID_CODE,
          LEGAL_REP_ID_CODE_DATA_SOURCE: proCache.source == "ecif" ? "4" : "",
          LEGAL_REP_ID_EXP_DATE: proCache.LEGAL_REP_ID_EXP_DATE,
          LEGAL_MOBILE_TEL_SOURCE: proCache.source == "ecif" ? "4" : "",
          LEGAL_MOBILE_TEL: proCache.LEGAL_MOBILE_TEL,
          LEGAL_PERSON_TEL_SOURCE: proCache.source == "ecif" ? "4" : "",
          LEGAL_PERSON_TEL: proCache.LEGAL_PERSON_TEL,
          IS_SAME_AGENT: "0"
        };
        _this.$blMethod.parseGroupsMouduleData(_this, ["LEGAL_MODULE"], legalInfo);
        _this.$blMethod.parseGroupsMouduleDataSource(_this, ["LEGAL_MODULE"], legalInfo);

        _.each(proCache.CONTROL_LIST_1, function (val) {
          for (var key in val) {
            if (proCache.source == "ecif") {
              val[key + "_DATASOURCE"] = "4";
            } else if (proCache.source == "cache") {
              val[key + "_DATASOURCE"] = "";
            }
          }
          val.IS_SAME_LEGAL_REP = "0";
        });
        _.each;
        _.each(proCache.CREDIT_LIST, function (val) {
          for (var key in val) {
            if (proCache.source == "ecif") {
              val[key + "_DATASOURCE"] = "4";
            } else if (proCache.source == "cache") {
              val[key + "_DATASOURCE"] = "";
            }
          }
        });

        _this.$blMethod.parseMoudleArray(_this, _this.groupDatas["CONTROLER_INFO_PAGE"]["CONTROLER_MODULE1"], proCache.CONTROL_LIST_1);
        _this.$blMethod.parseMoudleArray(_this, _this.groupDatas["TAX_INFO"]["CREDIT_INFO"], proCache.CREDIT_LIST);
      },
          canceledAction = function canceledAction() {
        return false;
      };
      _this.$blMethod.showMsgBox(_this, "检测到当前产品管理人{" + fields.PRO_MANAGER_NAME.DEFAULT_VALUE + "}信息已存在，是否直接复用？", confirmAction, canceledAction, "继续", "退出");
    }
  });
};

var QS421 = _.merge(_.cloneDeep(bizOrgOcr), _.cloneDeep(bizManagerImportantInfo), _.cloneDeep(bizZdInfoNode), _.cloneDeep(bizOrgAgentBasicInfoNode), _.cloneDeep(bizOrgOcrAgent), _.cloneDeep(bizProImportantInfoNode), _.cloneDeep(bizProBaseInfoNode), _.cloneDeep(bizManagerOtherInfo), _.cloneDeep(bizOtherLinkInfoNode), _.cloneDeep(bizOtherLegalInfoNode), _.cloneDeep(bizOtherAgentLinkInfoNode), _.cloneDeep(bizControlModuleInfoNode), _.cloneDeep(bizControlCustomModuleInfoNode), _.cloneDeep(bizProActualControllerInfo), _.cloneDeep(bizControlBeneficiaryInfoNode), _.cloneDeep(bizOtherCreditInfoNode), _.cloneDeep(bizTaxCustInfoNode), _.cloneDeep(bizTaxContolInfoNode), _.cloneDeep(bizProOtherInfoNode), _.cloneDeep(bizTrdAcctInfoNode), _.cloneDeep(bizAcctBsbInfoNode), _.cloneDeep(bizAcctAssetInfoNode), _.cloneDeep(bizAgentPhoneInfoNode), _.cloneDeep(bizPasswordInfoNode), {
  beforeLoadBiz: function () {
    var _ref = _asyncToGenerator(_regeneratorRuntime.mark(function _callee(_this) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.groupDatas.OTHER_INFO_PAGE.LEGAL_MODULE[0].FIELDS.LEGAL_REP_POSITION_PATION.FIELD_CONTROL = "1";
              _this.groupDatas.OTHER_INFO_PAGE.AGENT_LINK_MODULE[0].FIELDS.POSITION_PATION.FIELD_CONTROL = "1";
              _this.groupDatas.OTHER_INFO_PAGE.AGENT_LINK_MODULE[0].FIELDS.RELATION_PATION.FIELD_CONTROL = "1";
              _this.groupDatas.TAX_INFO.MA_CONTROLER_TAX_INFO_MODULE[0].FIELDS.TAX_RESIDENT_TYPE.FIELD_TYPE = "radio";
              _this.groupDatas.TAX_INFO.MA_CUST_TAX_INFO_MODULE[0].FIELDS.TAX_RESIDENT_TYPE.FIELD_TYPE = "radio";
              _this.groupDatas.TAX_INFO.MA_CUST_TAX_INFO_MODULE[0].FIELDS.IS_FINANCIAL_INSTITUTION.FIELD_TYPE = "radio";
              _this.groupDatas.TAX_INFO.MA_CUST_TAX_INFO_MODULE[0].FIELDS.PASSIVE_NFE.FIELD_TYPE = "radio";
              _this.groupDatas.TAX_INFO.MA_CONTROLER_TAX_INFO_MODULE[0].FIELDS.CTRL_SHARE_RATIO.VALID_TYPE = "number[100,100]|max[8]";

              _this.groupDatas.TAX_INFO.MA_CONTROLER_TAX_INFO_MODULE[0].MODULE_CONTROL = "0";
              _this.groupDatasTpl.TAX_INFO.MA_CONTROLER_TAX_INFO_MODULE[0].FIELDS.CTRL_SHARE_RATIO.VALID_TYPE = "number[100,100]|max[8]";

              _this.oppBusiData.validateResArr = [];

              bizOrgOcr.init(_this, { groupId: GROUP_INFO.OCR_ORG.GROUP_ID, moduleId: GROUP_INFO.OCR_ORG.IMP_OCR.MODULE_ID, savePath: GROUP_INFO.OCR_ORG.IMP_OCR.SAVE_PATH });
              bizZdInfoNode.init(_this, { groupId: GROUP_INFO.OCR_ORG.GROUP_ID, moduleId: GROUP_INFO.OCR_ORG.IMP_ZD.MODULE_ID, savePath: GROUP_INFO.OCR_ORG.IMP_ZD.SAVE_PATH, savePath2: GROUP_INFO.OCR_ORG.IMP_ZD.SAVE_PATH2 });

              bizProImportantInfoNode.init(_this, { groupId: GROUP_INFO.OCR_ORG.GROUP_ID, moduleId: GROUP_INFO.OCR_ORG.ZD.MODULE_ID, savePath: GROUP_INFO.OCR_ORG.ZD.SAVE_PATH });
              bizManagerImportantInfo.init(_this, { groupId: GROUP_INFO.OCR_ORG.GROUP_ID, moduleId: GROUP_INFO.OCR_ORG.IMP.MODULE_ID, savePath: GROUP_INFO.OCR_ORG.IMP.SAVE_PATH, savePath2: GROUP_INFO.OCR_ORG.IMP.SAVE_PATH2, savePath3: GROUP_INFO.OCR_ORG.IMP.SAVE_PATH3 });

              bizOrgAgentBasicInfoNode.init(_this, { groupId: GROUP_INFO.OCR_AGENT.GROUP_ID, moduleId: GROUP_INFO.OCR_AGENT.AGENT.MODULE_ID, savePath: GROUP_INFO.OCR_AGENT.AGENT.SAVE_PATH });
              bizOrgOcrAgent.init(_this, { groupId: GROUP_INFO.OCR_AGENT.GROUP_ID, moduleId: GROUP_INFO.OCR_AGENT.AGENT_OCR.MODULE_ID, savePath: GROUP_INFO.OCR_AGENT.AGENT_OCR.SAVE_PATH });

              bizProBaseInfoNode.init(_this, { groupId: GROUP_INFO.PRO.GROUP_ID, moduleId: GROUP_INFO.PRO.BASE.MODULE_ID, savePath: GROUP_INFO.PRO.BASE.SAVE_PATH });

              bizManagerOtherInfo.init(_this, { groupId: GROUP_INFO.MANAGER.GROUP_ID, moduleId: GROUP_INFO.MANAGER.OTHER.MODULE_ID, savePath: GROUP_INFO.MANAGER.OTHER.SAVE_PATH, savePath2: GROUP_INFO.MANAGER.OTHER.SAVE_PATH2, savePath3: GROUP_INFO.MANAGER.OTHER.SAVE_PATH3, savePath4: GROUP_INFO.MANAGER.OTHER.SAVE_PATH4 });

              bizOtherLinkInfoNode.init(_this, { groupId: GROUP_INFO.OTHER.GROUP_ID, moduleId: GROUP_INFO.OTHER.LINK.MODULE_ID, savePath: GROUP_INFO.OTHER.LINK.SAVE_PATH, savePath2: GROUP_INFO.OTHER.LINK.SAVE_PATH2, savePath3: GROUP_INFO.OTHER.LINK.SAVE_PATH3 });
              bizOtherLegalInfoNode.init(_this, { groupId: GROUP_INFO.OTHER.GROUP_ID, moduleId: GROUP_INFO.OTHER.LEGAL.MODULE_ID, savePath: GROUP_INFO.OTHER.LEGAL.SAVE_PATH, savePath2: GROUP_INFO.OTHER.LEGAL.SAVE_PATH2 });
              bizOtherAgentLinkInfoNode.init(_this, { groupId: GROUP_INFO.OTHER.GROUP_ID, moduleId: GROUP_INFO.OTHER.AGENT_LINK.MODULE_ID, savePath: GROUP_INFO.OTHER.AGENT_LINK.SAVE_PATH });

              bizControlModuleInfoNode.init(_this, { groupId: GROUP_INFO.CONTROLER.GROUP_ID, moduleId: GROUP_INFO.CONTROLER.CTRMODULE1.MODULE_ID, savePath: GROUP_INFO.CONTROLER.CTRMODULE1.SAVE_PATH });
              bizControlCustomModuleInfoNode.init(_this, { groupId: GROUP_INFO.CONTROLER.GROUP_ID, moduleId: GROUP_INFO.CONTROLER.CTRMODULE.MODULE_ID, savePath: GROUP_INFO.CONTROLER.CTRMODULE.SAVE_PATH });
              bizProActualControllerInfo.init(_this, { groupId: GROUP_INFO.CONTROLER.GROUP_ID, moduleId: GROUP_INFO.CONTROLER.CTRMODULE2.MODULE_ID, savePath: GROUP_INFO.CONTROLER.CTRMODULE2.SAVE_PATH });
              bizControlBeneficiaryInfoNode.init(_this, { groupId: GROUP_INFO.CONTROLER.GROUP_ID, moduleId: GROUP_INFO.CONTROLER.BENEFICIARY.MODULE_ID, savePath: GROUP_INFO.CONTROLER.BENEFICIARY.SAVE_PATH, savePath2: GROUP_INFO.CONTROLER.BENEFICIARY.SAVE_PATH2 });

              bizOtherCreditInfoNode.init(_this, { groupId: GROUP_INFO.TAX.GROUP_ID, moduleId: GROUP_INFO.TAX.CREDIT_INFO.MODULE_ID, savePath: GROUP_INFO.TAX.CREDIT_INFO.SAVE_PATH });

              bizTaxCustInfoNode.init(_this, { groupId: GROUP_INFO.TAX.GROUP_ID, moduleId: GROUP_INFO.TAX.CUST_INFO.MODULE_ID, savePath: GROUP_INFO.TAX.CUST_INFO.SAVE_PATH });
              bizTaxContolInfoNode.init(_this, { groupId: GROUP_INFO.TAX.GROUP_ID, moduleId: GROUP_INFO.TAX.CONTROLER_TAX.MODULE_ID, savePath: GROUP_INFO.TAX.CONTROLER_TAX.SAVE_PATH });

              bizTrdAcctInfoNode.init(_this, { groupId: GROUP_INFO.ACCT.GROUP_ID, moduleId: GROUP_INFO.ACCT.TRDACCT_INFO.MODULE_ID, savePath: GROUP_INFO.ACCT.TRDACCT_INFO.SAVE_PATH });
              bizAcctBsbInfoNode.init(_this, { groupId: GROUP_INFO.ACCT.GROUP_ID, moduleId: GROUP_INFO.ACCT.BSB_INFO.MODULE_ID, savePath: GROUP_INFO.ACCT.BSB_INFO.SAVE_PATH, savePath2: GROUP_INFO.ACCT.BSB_INFO.SAVE_PATH2 });
              bizAcctAssetInfoNode.init(_this, { groupId: GROUP_INFO.ACCT.GROUP_ID, moduleId: GROUP_INFO.ACCT.ASSET_INFO.MODULE_ID, savePath: GROUP_INFO.ACCT.ASSET_INFO.SAVE_PATH, savePath2: GROUP_INFO.ACCT.ASSET_INFO.SAVE_PATH2 });

              bizProOtherInfoNode.init(_this, { groupId: "OTHER_INFO_PAGE", moduleId: "PRO_TRUSTEE_INFO", savePath: GROUP_INFO.OTHER.OTHER_INFO.SAVE_PATH, savePath2: GROUP_INFO.OTHER.OTHER_INFO.SAVE_PATH2, savePath3: GROUP_INFO.OTHER.OTHER_INFO.SAVE_PATH3, savePath4: GROUP_INFO.OTHER.OTHER_INFO.SAVE_PATH4 });

              bizAgentPhoneInfoNode.init(_this, { groupId: GROUP_INFO.PASSWORD.GROUP_ID, moduleId: GROUP_INFO.PASSWORD.AGENT_PHONE_INFO.MODULE_ID, savePath: GROUP_INFO.PASSWORD.AGENT_PHONE_INFO.SAVE_PATH, savePath2: GROUP_INFO.PASSWORD.AGENT_PHONE_INFO.SAVE_PATH2 });
              bizPasswordInfoNode.init(_this, { groupId: GROUP_INFO.PASSWORD.GROUP_ID, moduleId: GROUP_INFO.PASSWORD.PASSWORD_INFO.MODULE_ID, savePath: GROUP_INFO.PASSWORD.PASSWORD_INFO.SAVE_PATH, savePath2: GROUP_INFO.PASSWORD.PASSWORD_INFO.SAVE_PATH2 });

              _this.oppBusiData.hideFields = {};
              if (_this.apptStatus >= 4) {
                _this.oppBusiData.hasAppvTask1 = true;
              }
              _this.oppBusiData.isShowBeneficiaryTypeAlert = false;
              return _context.abrupt("return", oppService.getSysCommonParamsFromCacheObjs("EFFECT_ID_TYPE").then(function (res) {
                _this.oppBusiData.EFFECT_ID_TYPE = res.split(",");
                return _Promise.all([].concat(_this.$blMethod.getPromiseArr(NODE_LIST, "beforeLoadBiz", _this, [_this]))).then(function (res) {
                  consoleLog("qs421 befoload执行完成");
                }).catch(function (err) {
                  console.error("初始化资料节点失败：", err);
                });
              }));

            case 39:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this2);
    }));

    return function beforeLoadBiz(_x) {
      return _ref.apply(this, arguments);
    };
  }(),
  afterLoadBiz: function () {
    var _ref2 = _asyncToGenerator(_regeneratorRuntime.mark(function _callee2(_this) {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt("return", _Promise.all([].concat(_this.$blMethod.getPromiseArr(NODE_LIST, "afterLoadBiz", _this, [_this]))).then(function (res) {
                if (!_.isEmpty(_.get(_this.historyData, "DETAIL_DATA.CSDC_INFO", {}))) {
                  _this.$blMethod.backFillCsdcInfo(_this, _this.historyData.DETAIL_DATA.CSDC_INFO, true);
                }

                if (!_.isEmpty(_.get(_this.historyData, "DETAIL_DATA.COMPANY_BASIC_INFO", {}))) {
                  _this.$blMethod.backFillCompanyInfo(_this, _this.historyData.DETAIL_DATA.COMPANY_BASIC_INFO);
                }
                console.log("afterLoadBiz执行完成");
              }).catch(function (err) {
                consoleError("初始化资料节点qs420afterloadbiz失败：", err);
              }));

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }));

    return function afterLoadBiz(_x2) {
      return _ref2.apply(this, arguments);
    };
  }(),
  pageActivated: function pageActivated(_this) {
    _this.oppBusiData.validateResArr = [];
    var func = function func(_this, nodeList) {
      return _.filter(nodeList, function (obj) {
        return obj.getModuleId && _this.moduleId.includes(obj.getModuleId());
      });
    };
    return _Promise.all([].concat(_this.$blMethod.getPromiseArrWithFilter(NODE_LIST, "pageActivated", _this, [_this], func))).then(function (res) {});
  },
  preValidate: function preValidate(_this) {
    _this.$blMethod.invoke(NODE_LIST, "preValidate", _this, [_this]);
  },
  validate: function validate(_this) {
    var func = function func(_this, nodeList) {
      return _.filter(nodeList, function (obj) {
        return obj.getModuleId && _this.moduleId.includes(obj.getModuleId());
      });
    };
    return _Promise.all([].concat(_this.$blMethod.getPromiseArrWithFilter(NODE_LIST, "validate", _this, [_this], func))).then(function (res) {
      if (_.includes(res, false)) {
        return false;
      }


      if (_this.oppBusiData.validateResArr.length) {
        if (_this.oppBusiData.validateResArr[0].alertType == "confirm") {
          return new _Promise(function (resolve, reject) {
            _this.confirm({
              messageText: _this.oppBusiData.validateResArr[0].messageText,
              cancelButtonText: "修改",
              confirmButtonText: "确定",
              confirmedAction: function confirmedAction() {
                _this.$store.commit(_this.$types.UPDATE_LOADING, false);
                resolve(true);
              },
              canceledAction: function canceledAction() {
                _this.$store.commit(_this.$types.UPDATE_LOADING, false);
                resolve(false);
              }
            });
          }).then(function (res) {
            return res;
          });
        } else if (_this.oppBusiData.validateResArr[0].alertType == "alert") {
          _this.alert(_this.oppBusiData.validateResArr[0].messageText);
          return false;
        }
        return false;
      }

      return true;
    }).catch(function (err) {
      console.error("校验失败", err.toString());
      return false;
    });
  },
  "beforeSave": function beforeSave(_this, params, baseData) {
    if (_.isEmpty(_this.moduleId)) {
      return;
    }
    var func = function func(_this, nodeList) {
      return _.filter(nodeList, function (obj) {
        return obj.getModuleId && _this.moduleId.includes(obj.getModuleId());
      });
    };
    return _Promise.all([].concat(_this.$blMethod.getPromiseArrWithFilter(NODE_LIST, "beforeSave", _this, [_this, params, baseData], func))).then(_asyncToGenerator(_regeneratorRuntime.mark(function _callee3() {
      var imgData, customerInfo, userInfo, dataUserCode;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              imgData = getImgBusiData(_this, params);

              params.IMG_DATA = _Object$assign(params.IMG_DATA || {}, imgData);
              customerInfo = _this.$storage.getJsonSession(_this.$definecfg.CUSTOMER_INFO);

              params.BIZ_DATA.NET_INFO = {
                NET_SERVICE: "0",
                NET_PASSWORD: ""
              };
              params.BIZ_DATA.ORG_CODE = customerInfo.INT_ORG;
              params.BIZ_DATA.SURVEY_RESULT_LIST = params.BIZ_DATA && params.BIZ_DATA.SURVEY_RESULT_LIST || [];
              params.BUSI_FLAG = "1";
              if (!_.isEmpty(_this.oppBusiData.OPENTMPL_INFO)) {
                _.set(params, "BIZ_DATA.OPENTMPL_INFO", _this.oppBusiData.OPENTMPL_INFO || {});
              }

              if (params.BIZ_DATA.NEW_CUST_CODE) {
                _context3.next = 12;
                break;
              }

              userInfo = _this.$storage.getJsonSession(_this.$definecfg.USER_INFO);
              dataUserCode = { ORG_CODE: userInfo.ORG_CODE };
              return _context3.abrupt("return", _this.$syscfg.K_Request("F0000020", dataUserCode).then(function (userCodeRes) {
                var NEW_CUST_CODE = void 0;
                if (userCodeRes.Code == "0") {
                  NEW_CUST_CODE = userCodeRes.Data[0].USER_CODE;
                }
                customerInfo.CUST_CODE = NEW_CUST_CODE;
                customerInfo.NEW_CUST_CODE = NEW_CUST_CODE;
                _this.$storage.setSession(_this.$definecfg.CUSTOMER_INFO, customerInfo);
                _.set(params, "BIZ_DATA.NEW_CUST_CODE", NEW_CUST_CODE);
              }));

            case 12:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, _this2);
    })));
  },
  "afterSave": function afterSave(_this, params) {
    if (_.isEmpty(_this.moduleId)) {
      return;
    }
    var func = function func(_this, nodeList) {
      return _.filter(nodeList, function (obj) {
        return obj.getGroupId && _this.groupId.includes(obj.getGroupId());
      });
    };
    return _Promise.all([].concat(_this.$blMethod.getPromiseArrWithFilter(NODE_LIST, "afterSave", _this, [_this], func))).then(function (res) {
      if (_.includes(res, false)) {
        return false;
      }
      return true;
    }).catch(function (err) {
      console.error("校验失败", err.toString());
      throw "preventNextStep";
    });
  },
  CHECK_OCR_ITEM: function CHECK_OCR_ITEM(_this, field, fieldData) {
    consoleLog("拍照字段关联逻辑触发，识别到的客户数据为", field.cardData);
    var cardData = field.cardData;
    _this.oppBusiData.isLoadData = true;
    if (field.MODULE_ID == "IMPORTANT_MODULE_OCR" && !_.isEmpty(cardData)) {
      (function () {
        _this.$blMethod.diabledFieldCheck(_this);

        var orgData = _this.groupDatas[field.GROUP_ID][field.MODULE_ID.split("_OCR")[0]][0].FIELDS;

        var _loop = function _loop(fk) {
          if (fk in orgData && orgData[fk]) {
            if (orgData[fk].DATA_SOURCE != 3) {
              orgData[fk].DEFAULT_VALUE = cardData[fk];
            }

            _this.$nextTick(function () {
              if (orgData[fk].DATA_SOURCE != 3) {
                orgData[fk].DATA_SOURCE = 1;
              }
            });
          }
        };

        for (var fk in cardData) {
          _loop(fk);
        }

        var zdModule = _this.groupDatas.OCR_ORG_INFO_PAGE.ZD_MODULE[0].FIELDS;
        if (!zdModule.ID_TYPE.DEFAULT_VALUE) {
          zdModule.ID_TYPE.DEFAULT_VALUE = cardData.ID_TYPE;
          zdModule.ID_TYPE.DATASOURCE = "1";
        }
        if (!zdModule.ID_CODE.DEFAULT_VALUE) {
          zdModule.ID_CODE.DEFAULT_VALUE = cardData.ID_CODE;
          zdModule.ID_CODE.DATASOURCE = "1";
        }
        setTimeout(function () {
          _this.$blMethod.enableFieldCheck(_this);
          _this.busiLogic.CHECK_ID_CODE(_this, _this.groupDatas.OCR_ORG_INFO_PAGE.IMPORTANT_MODULE[0].FIELDS.ID_CODE, _this.groupDatas.OCR_ORG_INFO_PAGE.IMPORTANT_MODULE[0].FIELDS);
          _this.busiLogic.GET_ZZ_DATA(_this, _this.groupDatas.OCR_ORG_INFO_PAGE.IMPORTANT_MODULE[0].FIELDS.ID_CODE, _this.groupDatas.OCR_ORG_INFO_PAGE.IMPORTANT_MODULE[0].FIELDS);
        }, 1000);
      })();
    } else if (field.MODULE_ID == "AGENT_MODULE_OCR" && !_.isEmpty(cardData)) {
      (function () {
        _this.$blMethod.diabledFieldCheck(_this);

        var agentData = _this.groupDatas[field.GROUP_ID][field.MODULE_ID.split("_OCR")[0]][0].FIELDS;
        if (cardData.address) {
          cardData.AGENT_USER_FNAME = cardData.name || "";

          cardData.AGENT_ID_TYPE = "00";

          cardData.AGENT_ID_CODE = cardData.id_number || "";

          cardData.AGENT_BIRTHDAY = cardData.birthday.replace(/年|月|日/g, "") || "";

          cardData.AGENT_SEX = cardData.sex == "男" ? "0" : "1" || "";
        }
        if (cardData.validity) {
          cardData.AGENT_ID_EXP_DATE = cardData.validity ? cardData.validity.split("-")[1].replaceAll(".", "") : "";
        }

        var _loop2 = function _loop2(fk) {
          if (fk in agentData && agentData[fk]) {
            if (agentData[fk].DATA_SOURCE != 3) {
              agentData[fk].DEFAULT_VALUE = cardData[fk];
            }
            _this.$nextTick(function () {
              if (agentData[fk].DATA_SOURCE != 3) {
                agentData[fk].DATA_SOURCE = 1;
              }
            });
          }
        };

        for (var fk in cardData) {
          _loop2(fk);
        }
        setTimeout(function () {
          _this.$blMethod.enableFieldCheck(_this);
        }, 1000);
      })();
    }
    setTimeout(function () {
      _this.oppBusiData.isLoadData = false;
      field.cardData = {};
    }, 500);
  },
  CHECK_MOBILE_TEL__CLICK: function CHECK_MOBILE_TEL__CLICK(_this, field, fieldData) {
    if (field.MODULE_ID == "AGENT_LINK_MODULE") {
      if (!field.DEFAULT_VALUE) {
        alert("请填写手机号！");
        return;
      }
      var APPT_SN = _this.$storage.getSession(_this.$definecfg.APPT_SN) || "";
      _this.loading = true;
      _this.loadingText = "正在发送...";
      _this.$syscfg.K_Request("F0000041", {
        APPT_SN: APPT_SN,
        type: 2,
        phoneNo: field.DEFAULT_VALUE,
        BUSI_CODE: _this.busiCode,
        USER_TYPE: _this.userType
      });
      var remainTime = field.remainTime || 120;
      _this.$set(field, "remainTime", remainTime);

      _this.$set(field, "codeStatus", "codeStart");
      _this.oppBusiData.isAssignValidCodeTimeout = true;
      setTimeout(function () {
        _this.oppBusiData.isAssignValidCodeTimeout = false;
        _this.$set(field, "codeStatus", "codeEnd");
      }, remainTime * 1000);
    }
  },
  "CHECK_OCR_ITEM__CLICK": function CHECK_OCR_ITEM__CLICK(_this, field, fieldData) {
    _this.$vtmDispatch(_this, "bizFlow", "parseBizData");

    var func = function func(_this, nodeList) {
      return _.filter(nodeList, function (obj) {
        return obj.getModuleId && ["IMPORTANT_MODULE_OCR", "IMPORTANT_MODULE_ZD", "IMPORTANT_MODULE", "AGENT_MODULE_OCR", "AGENT_MODULE"].includes(obj.getModuleId());
      });
    };
    return _Promise.all([].concat(_this.$blMethod.getPromiseArrWithFilter(NODE_LIST, "afterLoadBiz", _this, [_this], func))).then(function (res) {
      if (_.includes(res, false)) {
        return false;
      }
      return true;
    }).catch(function (err) {
      console.error("校验失败", err.toString());
      return false;
    });
  },
  "CHECK_ID_TYPE": function CHECK_ID_TYPE(_this, field, fieldData) {
    fieldData.ID_CODE.DEFAULT_VALUE = "";
    if (field.DEFAULT_VALUE == "10") {
      fieldData.ID_CODE.VALID_TYPE = "code_fixed_len[18,24]|on-blur";
    } else {
      fieldData.ID_CODE.VALID_TYPE = "length[0,48]|on-blur";
    }
  },
  "CHECK_CUST_FNAME": function CHECK_CUST_FNAME(_this, field, fieldData) {
    if (field.MODULE_ID == "ZD_MODULE") {
      return getProCache(_this, fieldData);
    }
  },
  "CHECK_ID_CODE": function () {
    var _ref4 = _asyncToGenerator(_regeneratorRuntime.mark(function _callee4(_this, field, fieldData) {
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              if (!(field.MODULE_ID == "IMPORTANT_MODULE")) {
                _context4.next = 4;
                break;
              }

              if (field.DEFAULT_VALUE) {
                _context4.next = 3;
                break;
              }

              return _context4.abrupt("return");

            case 3:
              if (field.DEFAULT_VALUE.length == 18) {
                _this.oppBusiData.hideFields.ORG_ID_CODE = {
                  value: field.DEFAULT_VALUE.slice(8, 16) + "-" + field.DEFAULT_VALUE.slice(16, 17),
                  DATA_SOURCE: "0"
                };
              } else if (field.DEFAULT_VALUE.length == 24) {
                _this.oppBusiData.hideFields.ORG_ID_CODE = {
                  value: field.DEFAULT_VALUE.slice(15, 23) + "-" + field.DEFAULT_VALUE.slice(23, 24),
                  DATA_SOURCE: "0"
                };
              }

            case 4:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, this);
    }));

    function CHECK_ID_CODE(_x3, _x4, _x5) {
      return _ref4.apply(this, arguments);
    }

    return CHECK_ID_CODE;
  }(),
  "GET_PRO_CACHE": function () {
    var _ref5 = _asyncToGenerator(_regeneratorRuntime.mark(function _callee5(_this, field, fieldData) {
      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              if (!(field.MODULE_ID == "ZD_MODULE")) {
                _context5.next = 2;
                break;
              }

              return _context5.abrupt("return", getProCache(_this, fieldData));

            case 2:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, this);
    }));

    function GET_PRO_CACHE(_x6, _x7, _x8) {
      return _ref5.apply(this, arguments);
    }

    return GET_PRO_CACHE;
  }(),
  "GET_ZZ_DATA": function GET_ZZ_DATA(_this, field, fieldData) {
    return true;
  },
  "CHECK_PRO_MANAGER_NAME": function CHECK_PRO_MANAGER_NAME(_this, field, fieldData) {
    return getProManagerInfo(_this, fieldData);
  },
  addModuleFinished: function addModuleFinished(_this, moduleObj, moduleArr) {
    if (moduleObj.MODULE_ID == "CREDIT_INFO") {
      tools.addCreditModule(_this, moduleObj);
    }

    if (moduleObj.MODULE_ID == "CREDIT_INFO") {
      tools.addCreditModule(_this, moduleObj);
    }

    _this2.default.moduleFinished(_this, moduleObj, moduleArr, true);
  },
  deleteModuleFinished: function deleteModuleFinished(_this, modules, moduleArr) {
    if (modules.MODULE_ID == "CREDIT_INFO") {
      tools.addCreditModule(_this, modules, true);
    }
    _this2.default.moduleFinished(_this, modules, moduleArr, false);
  },

  moduleFinished: function moduleFinished(_this, moduleObj, moduleArr, flag) {
    if (_this.groupId === "CONTROLER_INFO_PAGE" && moduleObj.MODULE_ID === "BENEFICIARY_MODULE") {
      flag && _this2.default.moduleFinishedConfig(_this, moduleObj);
      flag && bizBenefitMethod.handlerClassBeneficiaryIdType(_this);
    } else if (_this.groupId === "CONTROLER_INFO_PAGE" && moduleObj.MODULE_ID === "BENEFICIARY_MODULE_1") {
      flag && _this2.default.moduleFinishedConfig(_this, moduleObj);
      flag && bizBenefitMethod.getFilterFieldDictProductsField(_this, bizBenefitMethod.ONE, moduleObj);
    } else if (_this.groupId === "CONTROLER_INFO_PAGE" && moduleObj.MODULE_ID === "BENEFICIARY_MODULE_0") {
      flag && _this2.default.moduleFinishedConfig(_this, moduleObj);
      flag && bizBenefitMethod.getFilterFieldDictProductsField(_this, bizBenefitMethod.ZERO, moduleObj);
      moduleArr.length < 2 && (moduleObj.MODULE_WITHOUT = "1");
    } else if (_this.groupId === "CONTROLER_INFO_PAGE" && moduleObj.MODULE_ID === "BENEFICIARY_MODULE_2") {
      flag && _this2.default.moduleFinishedConfig(_this, moduleObj);
      flag && bizBenefitMethod.getFilterFieldDictProductsField(_this, bizBenefitMethod.TWO, moduleObj);
      moduleArr.length < 2 && (moduleObj.MODULE_WITHOUT = "1");
    } else if (_this.groupId === "CONTROLER_INFO_PAGE" && moduleObj.MODULE_ID === "BENEFICIARY_MODULE_3") {
      flag && _this2.default.moduleFinishedConfig(_this, moduleObj);
      flag && bizBenefitMethod.getFilterFieldDictProductsField(_this, bizBenefitMethod.THREE, moduleObj);
      moduleArr.length < 2 && (moduleObj.MODULE_WITHOUT = "1");
    } else if (_this.groupId === "CONTROLER_INFO_PAGE" && moduleObj.MODULE_ID === "BENEFICIARY_MODULE_4") {
      flag && _this2.default.moduleFinishedConfig(_this, moduleObj);
      flag && bizBenefitMethod.getFilterFieldDictProductsField(_this, bizBenefitMethod.FOUR, moduleObj);
      moduleArr.length < 2 && (moduleObj.MODULE_WITHOUT = "1");
    }
  },

  moduleFinishedConfig: function moduleFinishedConfig(_this, moduleObj) {
    var fields = moduleObj.FIELDS;
    fields.IS_SAME_LEGAL_REP && (fields.IS_SAME_LEGAL_REP.FIELD_TYPE = "radio");
    fields.IS_SAME_LEGAL_REP && (fields.IS_SAME_LEGAL_REP.FIELD_CONTROL = "1");
    fields.BENEFICIARY_TEL.VALID_TYPE = "mobileortel";
    fields.BENEFICIARY_ID_TYPE.FIELD_DICT_NAME = _.filter(fields.BENEFICIARY_ID_TYPE.FIELD_DICT_NAME, function (item) {
      return _this.oppBusiData.EFFECT_ID_TYPE.includes(item.DICT_ITEM) && item.DICT_ITEM[0] == "0";
    });
    fields.SHARE_RATIO.unitText = "%";
    _.set(fields, "NATION.FIELD_TYPE", "selector");

    fields.IS_UPLOAD_IMG.DEFAULT_VALUE = "0";
  }

});

export default QS421;


//////////////////
// WEBPACK FOOTER
// ./src/business/businessFile/QS421/QS421.js
// module id = 283
// module chunks = 2